import dataLayer from '../core/dataLayer'

export default {

    arrayIndexOf () {
        // Restore the Array.indexOf on Classic env
        if (dataLayer.isClassic) {
            /* eslint-disable no-extend-native */
            Array.prototype.indexOf = function (a, b) {
                for (var c = b || 0; c < this.length; c++) {
                    if (this[c] === a) {
                        return c
                    }
                }
                return -1
            }
        }
    }

}
